import { usePrintDesignsGalleryEventInfoByEventHandleQuery } from '@graphql/generated';

export const useEventDesignThemeId = (eventHandle?: string) => {
  const { data: eventInfoData } = usePrintDesignsGalleryEventInfoByEventHandleQuery({
    batchMode: 'fast',
    variables: {
      eventHandle: eventHandle || '',
    },
    fetchPolicy: 'cache-first',
    skip: !eventHandle,
  });
  return eventInfoData?.eventByName?.eventDesign?.theme.themeId;
};
